import React from 'react';
import { createComponent } from '@workday/canvas-kit-react/common';
import { SystemIcon } from '@workday/canvas-kit-react/icon';
export const ToastIcon = createComponent('div')({
    displayName: 'Toast.Icon',
    Component: (elemProps, ref, Element) => {
        return (React.createElement(SystemIcon, Object.assign({ colorHover: elemProps.color, marginY: "s", marginX: "xs", alignSelf: "start", ref: ref, as: Element }, elemProps)));
    },
});
